export default __webpack_public_path__ + "static/media/img_01.66ca0a76.png";